import React from "react";

export default function StreamCursor({ active }) {
  if (!active) return null;
  return <span className="nl-stream-cursor" aria-hidden="true" />;
}
